const preventInitialInputValueNames = ["country"];

const getInitialSelectInput = (input) => {
	let initialSelectInput;
	if (
		input.type === "select" &&
		Array.isArray(input.options) &&
		input.options.length
	) {
		initialSelectInput = input.options?.[0]?.value;
		if (
			input.initialValue &&
			input.options.some(
				({ value }) => value.toString() === input.initialValue.toString()
			)
		) {
			initialSelectInput = input.initialValue;
		}
	}

	return initialSelectInput;
};

export const getInputsWithoutAdditionalFields = (
	inputs = {},
	formGroups = []
) => {
	const inputsWithoutAdditionalFields = { ...inputs };
	for (const inputName in inputs) {
		const input = inputs[inputName];
		if (
			input.type !== "select" ||
			!Array.isArray(input.options) ||
			!input.options.length
		) {
			continue;
		}

		input.options.forEach((option) => {
			option.displays?.forEach((additionalField) => {
				if (formGroups[additionalField]) {
					formGroups[additionalField].formFields?.forEach((groupField) => {
						delete inputsWithoutAdditionalFields[groupField];
					});
				} else {
					delete inputsWithoutAdditionalFields[additionalField];
				}
			});
		});
	}
	return inputsWithoutAdditionalFields;
};

export const getInitialInput = (input) => {
	if (!input.name) return;
	const newInput = { ...input };
	if (!preventInitialInputValueNames.includes(input.name)) {
		if (newInput.type === "select") {
			newInput.value = getInitialSelectInput(newInput);
		} else if (newInput.initialValue) {
			newInput.value = newInput.initialValue;
		}
	}
	return newInput;
};

export const getInitialInputs = (inputs, formGroups) => {
	inputs = getInputsWithoutAdditionalFields(inputs, formGroups);

	const initialInputs = {};
	for (const inputName in inputs) {
		const input = getInitialInput(inputs[inputName]);
		if (!input?.value) continue;
		initialInputs[inputName] = input.value;
	}
	return initialInputs;
};

const getLinkedChildFieldOptions = (input, parentValue) => {
	if (!input.options?.length) return;
	let options = input.options.filter(
		(option) =>
			option.parentOptionLinkedTo?.toString() === parentValue?.toString()
	);

	if (
		options.length &&
		input.options[0].text &&
		input.options[0].value === ""
	) {
		options = [input.options[0], ...options];
	}
	return options;
};

export const getAdditionalFields = (additionalFields) => {
	let inputs = [];
	for (const inputName in additionalFields) {
		if (
			Array.isArray(additionalFields[inputName].fields) &&
			additionalFields[inputName].fields.length
		) {
			inputs = inputs.concat(
				additionalFields[inputName].fields.flatMap((additionalField) =>
					Array.isArray(additionalField.formFields) &&
					additionalField.formFields.length
						? additionalField.formFields
						: additionalField
				)
			);
		}
	}
	return inputs;
};

export const getSelectedOptionAdditionalFieldsLinkedTo = (
	fieldAdditionalFieldsLinkedTo,
	value
) => {
	return (
		fieldAdditionalFieldsLinkedTo?.options?.find(
			(item) => item.value?.toString() === value?.toString()
		) || {}
	);
};

export const initializeLinkedFieldChild = (
	childInput,
	parentInput,
	parentValue
) => {
	const linkedField = {};
	if (childInput.type === "select") {
		const options = getLinkedChildFieldOptions(childInput, parentValue);
		if (options) {
			linkedField.options = options;
			linkedField.value = getInitialSelectInput(childInput);
		}
	} else {
		const parentSelectedOption = parentInput.options?.find((option) => {
			return option.value && option.value === parentValue;
		});
		linkedField.value = parentSelectedOption?.text;
	}
	return linkedField;
};

export const getFilePath = (file) =>
	new Promise((resolve, reject) => {
		const fileReader = new FileReader();
		fileReader.onload = (e) => resolve(fileReader.result);
		fileReader.onerror = (error) => reject(error);
		// reading the actual uploaded file
		fileReader.readAsDataURL(file);
	});

export const focusFirstInvalidField = (ids = []) => {
	const elementsWithError = document.querySelectorAll(`#${ids.join(", #")}`);
	const datePickerSelector = "wdpr-input.invalid";
	const singleSelectSelector = "wdpr-single-select[invalid]";
	focusElement(elementsWithError, datePickerSelector, singleSelectSelector);
};

const focusElement = (
	elementsToFocus,
	datePickerSelector,
	singleSelectSelector
) => {
	const helpInput = document.querySelector(".help-input-text__input");
	const datePicker = document.querySelector("wdpr-datepicker");
	const datepickerToFocus = datePicker?.shadowRoot?.querySelector(
		datePickerSelector
	);
	const singleSelect = document.querySelector(singleSelectSelector);
	switch (elementsToFocus?.[0]?.nodeName) {
		case helpInput?.nodeName:
			elementsToFocus[0]?.focus();
			elementsToFocus[0]?.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest",
			});
			break;
		case singleSelect?.nodeName:
			elementsToFocus[0]?.focusDropdown();
			elementsToFocus[0]?.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest",
			});
			break;
		case datePicker?.nodeName:
			datepickerToFocus?.shadowRoot?.querySelector("button")?.click();
			datepickerToFocus?.shadowRoot?.querySelector("input")?.focus();
			datepickerToFocus?.shadowRoot
				?.querySelector("wdpr-input")
				?.scrollIntoView({
					behavior: "smooth",
					block: "start",
					inline: "nearest",
				});
			break;
		default:
			elementsToFocus[0]?.focus();
			elementsToFocus[0]?.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest",
			});
	}
};

export const isFormEmpty = (formInputs) => {
	for (const fieldName in formInputs) {
		if (fieldName === "files" && formInputs[fieldName]?.[0]) {
			return false;
		}
		if (formInputs[fieldName] && fieldName !== "files") {
			return false;
		}
	}
	return true;
};
